import apiAllUsers from '@/api/all-users'

const state = {
  error: null,
  isSubmitting: false
}

export const mutationTypes = {
  createAllUsersStart: '[create all users] Create all users start',
  createAllUsersSuccess: '[create all users] Create all users success',
  createAllUsersFailure: '[create all users] Create all users failure'
}

export const actionTypes = {
  createAllUsers: '[create all users] Create all users'
}

const mutations = {
  [mutationTypes.createAllUsersStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.createAllUsersSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.createAllUsersFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.createAllUsers](context, {allUsersInput}) {
    context.commit(mutationTypes.createAllUsersStart)
    return new Promise(resolve => {
      apiAllUsers
        .createAllUsers(allUsersInput)
        .then(response => {
          context.commit(mutationTypes.createAllUsersSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.createAllUsersFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
